










import { Vue, Component } from 'vue-property-decorator';
import CertificadorBHP from '@/pantallas/CertificadorBHP/CertificadorBHP.vue';

@Component({
  components: { CertificadorBHP },
})
export default class CertificadorBHPPantalla extends Vue {}
